export const getUrgenciesList = (
  urgencies: { id: number; name: string; disabled?: boolean }[],
  t: (text: string) => void,
) => {
  const urgenciesList = [
    { value: 'all', label: t('All') },
    ...urgencies.map((urgency) => ({ value: urgency.id, label: urgency.name, disabled: urgency.disabled })),
  ];
  return urgenciesList;
};
